import type {FocusEventHandler} from 'react';
import React from 'react';
import type {FieldError} from 'schemaDefinition/types';
import {FlexBox, Layout} from '../layout';
import {Spacer} from '../spacer';
import {ListActionButton} from './ListActionButton';

type Props = {
  handleAppendValue: (prepend?: boolean) => void;
  handleDeleteAll: () => void;
  renderCustomActions?: () => React.ReactNode;
  canAdd: boolean;
  canDeleteAll: boolean;
  addLabel?: string;
  addError?: FieldError;
  deleteAllStrings?: {
    label?: string;
    confirm: {
      title?: string;
      okTitle?: string;
      cancelTitle?: string;
    };
  };
  itemPadding?: string | number;
  handleAddBlur?: FocusEventHandler<HTMLDivElement> | undefined;
  prependAdd?: boolean;
};

export function SingleValueListFieldActions({
  handleAppendValue,
  handleDeleteAll,
  renderCustomActions,
  canDeleteAll,
  canAdd,
  deleteAllStrings,
  addLabel,
  addError,
  itemPadding,
  handleAddBlur,
  prependAdd,
}: Props) {
  if (renderCustomActions) {
    return (
      <Layout
        horizontal
        adjustCenter
        justifyContent={'space-between'}
        px={itemPadding}>
        <FlexBox horizontal center>
          {canAdd ? (
            <ListActionButton
              icon="Add"
              label={addLabel}
              error={addError}
              onBlur={handleAddBlur}
              onClick={() => handleAppendValue(prependAdd)}
            />
          ) : null}
          <Spacer width={2} />
          {renderCustomActions()}
        </FlexBox>
        {canDeleteAll ? (
          <ListActionButton
            label={deleteAllStrings?.label}
            icon="Delete"
            iconPosition="right"
            onClick={handleDeleteAll}
          />
        ) : (
          <FlexBox />
        )}
      </Layout>
    );
  }

  if (canAdd || canDeleteAll) {
    return (
      <FlexBox horizontal center spaceBetween>
        {canAdd ? (
          <ListActionButton
            icon="Add"
            label={addLabel}
            error={addError}
            onBlur={handleAddBlur}
            onClick={() => handleAppendValue(prependAdd)}
          />
        ) : null}
        {canDeleteAll ? (
          <ListActionButton
            label={deleteAllStrings?.label}
            icon="Delete"
            iconPosition="right"
            onClick={handleDeleteAll}
          />
        ) : (
          <FlexBox />
        )}
      </FlexBox>
    );
  }

  return null;
}
